import React, { useState, useEffect } from "react"
import styles from "../../assets/stylesheets/pages/tools/tools.module.scss"
import ApiActions from "../../actions/ApiActions"
import jwt_decode from "jwt-decode"

export default function AgentNumberChange() {
    const [fromNumber, setFromNumber] = useState("")
    const [toNumber, setToNumber] = useState("")
    const [fromData, setFromData] = useState(null)
    const [toData, setToData] = useState(null)
    const [loadingFrom, setLoadingFrom] = useState(false)
    const [loadingTo, setLoadingTo] = useState(false)
    const [otpSent, setOtpSent] = useState(false)
    const [fromOtp, setFromOtp] = useState("")
    const [toOtp, setToOtp] = useState("")
    const [resendFromNumberOTPTimer, setResendFromNumberOTPTimer] = useState(0)
    const [resendToNumberOTPTimer, setResendToNumberOTPTimer] = useState(0)
    const [message, setMessage] = useState(null)

    const fetchAgent = async (mobile) => {
        const user = await ApiActions.getAgentDetails(mobile)
        if (!user || user.code == "171235") {
            return null
        }
        const role = jwt_decode(localStorage.authToken).auth
        if (role === "team_lead" && user.team && user.team.teamLeadName && localStorage.userName) {
            if (user.team.teamLeadName !== localStorage.userName) {
                alert("You are not authorized to migrate this number")
                return null
            }
        }
        const wallet = await ApiActions.getWalletBalance(user.id)
        const applications = await ApiActions.fetchProjectsOfAgent(user.id)
        const workingProjects = await ApiActions.getCallerJobHistory({ user: user.id, status: "inprogress" })
        const pendingPayment = await ApiActions.fetchPendingPayments({ mobile })
        return {
            mobile: user.mobile,
            name: user.firstname ? user.firstname + " " : '' + user.lastname ? user.lastname : '',
            email: user.email,
            certifiedCaller: user.certifiedCaller,
            aadharKyc: user.aadharKyc && user.aadharKyc.status || 'Not available',
            walletbalance: wallet[0] && wallet[0].balance || 0,
            workingProjects: workingProjects.length || 0,
            totalProjects: applications.length || 0,
            pendingPayment: pendingPayment.pendingPaymentsAmount || 0
        }
    }

    const handleSearch = async (type) => {
        if (type === "from") {
            if (fromNumber.length !== 10) {
                alert("Enter a valid 10-digit mobile number")
                return
            }

            setLoadingFrom(true)
            try {
                const data = await fetchAgent(fromNumber)
                setFromData(data || null)
            } catch (err) {
                console.error(err)
                alert("Failed to fetch details. Please try again.")
                setFromData(null)
            } finally {
                setLoadingFrom(false)
            }

        } else {
            if (toNumber.length !== 10) {
                alert("Enter a valid 10-digit mobile number")
                return
            }

            setLoadingTo(true)
            try {
                const data = await fetchAgent(toNumber)
                setToData(data || null)
            } catch (err) {
                console.error(err)
                let apiError = ""
                if (
                    err &&
                    err.response &&
                    err.response.data &&
                    typeof err.response.data.error === "string"
                ) {
                    apiError = err.response.data.error
                }
                if (typeof apiError === "string" && apiError.toLowerCase().includes("user not found")) {
                    setToData("no user")
                } else {
                    setToData(false)
                }
            } finally {
                setLoadingTo(false)
            }
        }
    }

    const isEligible = (data, type) => {
        if (!data) return false
        if (type === "from") {
            return Boolean(data.name && data.email)
        } else {
            if (data.walletbalance > 0 || data.workingProjects > 0 || data.pendingPayment > 0) {
                return false
            } else if (data == "no user") {
                return true
            }
            return true
        }
    }
    const canProceed = isEligible(fromData, "from") && toNumber.length === 10 && toData ? isEligible(toData, "to") : false

    const handleSubmit = async () => {
        try {
            const fromNumberOtpConfirmation = await ApiActions.confirmNumberChangeOTP({ mobile: fromData.mobile, otp: fromOtp })
            const toNumberOtpConfirmation = await ApiActions.confirmNumberChangeOTP({ mobile: toData.mobile || toNumber, otp: toOtp })
            if (fromNumberOtpConfirmation.code && fromNumberOtpConfirmation.code == 200 && toNumberOtpConfirmation.code && toNumberOtpConfirmation.code == 200) {
                const numberChange = await ApiActions.submitNumberChangeRequest({ fromData, toData: { ...toData, mobile: toNumber } })
                if (numberChange.data && numberChange.data.code && numberChange.data.code == 200) {
                    setMessage({ type: "success", text: "Number changed successfully! Aadhaar and PAN KYC have been reset for security reasons. Please ask the Service Provider to complete KYC again." })
                    setFromData(null)
                    setToData(null)
                    setOtpSent(false)
                    setFromOtp("")
                    setToOtp("")
                }
            }
        } catch (err) {
            console.error(err)
            setMessage({ type: "error", text: err.response.data.msg || "Number change failed!" })
        }
    }

    useEffect(() => {
        if (resendFromNumberOTPTimer === 0) return
        const t = setInterval(() => setResendFromNumberOTPTimer((sec) => sec - 1), 1000)
        return () => clearInterval(t)
    }, [resendFromNumberOTPTimer])

    useEffect(() => {
        if (resendToNumberOTPTimer === 0) return
        const t = setInterval(() => setResendToNumberOTPTimer((sec) => sec - 1), 1000)
        return () => clearInterval(t)
    }, [resendToNumberOTPTimer])

    const sendFromNumberOtp = async () => {
        const res = await ApiActions.sendNumberChangeOTP({ mobile: fromData.mobile })
        if (res.code && res.code == 200) {
            setOtpSent(true)
            setResendFromNumberOTPTimer(30)
            setMessage(null)
        } else {
            alert("Failed to send OTP. Please try again.")
        }
    }
    const sendToNumberOtp = async () => {
        const res = await ApiActions.sendNumberChangeOTP({ mobile: toData.mobile || toNumber })
        if (res.code && res.code == 200) {
            setOtpSent(true)
            setResendToNumberOTPTimer(30)
            setMessage(null)
        } else {
            alert("Failed to send OTP. Please try again.")
        }
    }

    return (
        <div className={styles.agentNumberChange}>
            <h2 className={styles.title}>Agent Number Change Tool</h2>

            <div style={{ margin: "0 auto 24px", maxWidth: "1100px", padding: "12px 16px", borderRadius: "6px", backgroundColor: "#fff8e0", border: "1px solid #ffe8a1", color: "#856404", fontSize: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                <span>⚠️</span>
                <span><strong>Important Notice:</strong> Migrating an agent's number will automatically reset their Aadhaar and PAN KYC details. The agent must complete their KYC verification again after the migration.</span>
            </div>

            <div className={styles.columns}>
                <div className={styles.card}>
                    <div className={styles["input-row"]}>
                        <input
                            placeholder="From Number"
                            value={fromNumber}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10)
                                setFromNumber(value)
                                setFromData(null)
                                setOtpSent(false)
                                setFromOtp("")
                                setMessage(null)
                            }}
                        />
                        <button onClick={() => handleSearch("from")} disabled={fromNumber.length !== 10}>{loadingFrom ? "..." : "Search"}</button>
                    </div>
                    {fromData && (
                        <div className={styles.details}>
                            <div>Agent Name: <strong>{fromData.name}</strong></div>
                            <div>Agent Email: <strong>{fromData.email}</strong></div>
                            <div>Certified Caller: <strong>{fromData.certifiedCaller ? "Yes" : "No"}</strong></div>
                            <div>Wallet Balance: <strong>{fromData.walletbalance !== null && fromData.walletbalance !== undefined ? fromData.walletbalance : "NA"}</strong></div>
                            <div>Total Projects: <strong>{fromData.totalProjects}</strong></div>
                            <div>Current Projects: <strong>{fromData.workingProjects}</strong></div>
                            <div>Aadhar KYC: <strong>{fromData.aadharKyc || "NA"}</strong></div>
                            <div>Pending Payment: <strong>{fromData.pendingPayment}</strong></div>
                        </div>
                    )}
                </div>

                <div className={styles.card}>
                    <div className={styles["input-row"]}>
                        <input
                            placeholder="To Number"
                            value={toNumber}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10)
                                setToNumber(value)
                                setToData(null)
                                setOtpSent(false)
                                setToOtp("")
                                setMessage(null)
                            }}
                        />
                        <button onClick={() => handleSearch("to")} disabled={toNumber.length !== 10}>{loadingTo ? "..." : "Search"}</button>
                    </div>
                    {toData && toData !== "no user" && (
                        <div className={styles.details}>
                            <div>Agent Name: <strong>{toData.name}</strong></div>
                            <div>Agent Email: <strong>{toData.email}</strong></div>
                            <div>Certified Caller: <strong>{toData.certifiedCaller ? "Yes" : "No"}</strong></div>
                            <div style={{ color: toData.walletbalance > 0 ? "red" : "inherit" }}> Wallet Balance: <strong>{toData.walletbalance !== null && toData.walletbalance !== undefined ? toData.walletbalance : "NA"}</strong> </div>
                            <div>Total Projects: <strong>{toData.totalProjects}</strong></div>
                            <div style={{ color: toData.workingProjects > 0 ? "red" : "inherit" }}>Current Projects: <strong>{toData.workingProjects}</strong></div>
                            <div>Aadhar KYC: <strong>{toData.aadharKyc || "NA"}</strong></div>
                            <div style={{ color: toData.pendingPayment > 0 ? "red" : "inherit" }}> Pending Payment: <strong>{toData.pendingPayment}</strong> </div>
                        </div>
                    )}
                </div>
            </div>

            {
                canProceed && !otpSent ? (
                    <div className={styles["otp-section"]}>
                        <button onClick={() => {
                            sendToNumberOtp()
                            sendFromNumberOtp()
                        }}>Send OTP</button>
                    </div>
                ) : fromData && toData && !isEligible(toData) && (
                    <div className={`${styles.message} ${styles.error}`}> Migration not allowed</div>
                )
            }

            {canProceed && otpSent && (
                <div className={styles["otp-section"]}>
                    <input
                        style={{ width: "200px" }}
                        placeholder="Enter From Number OTP"
                        value={fromOtp}
                        onChange={(e) =>
                            setFromOtp(e.target.value.replace(/[^0-9]/g, "").slice(0, 4))
                        }
                    />

                    {resendFromNumberOTPTimer > 0 ? (
                        <button disabled>{`Resend OTP (${resendFromNumberOTPTimer}s)`}</button>
                    ) : (
                        <button onClick={sendFromNumberOtp}>Resend OTP</button>
                    )}

                    <input
                        style={{ width: "200px" }}
                        placeholder="Enter To Number OTP"
                        value={toOtp}
                        onChange={(e) =>
                            setToOtp(e.target.value.replace(/[^0-9]/g, "").slice(0, 4))
                        }
                    />

                    {resendToNumberOTPTimer > 0 ? (
                        <button disabled>{`Resend OTP (${resendToNumberOTPTimer}s)`}</button>
                    ) : (
                        <button onClick={sendToNumberOtp}>Resend OTP</button>
                    )}

                    <button onClick={handleSubmit} disabled={fromOtp.length !== 4 || toOtp.length !== 4}>
                        Submit
                    </button>
                </div>
            )}

            {message && (
                <div className={`${styles.message} ${styles[message.type]}`}>
                    {message.text}
                </div>
            )}
        </div>
    )
}
